import React from 'react';
import "./BannerSectionStyle3.scss"
// import parse from 'html-react-parser';
// import Button from '../../Button';
// import Spacing from '../../Spacing';

// export default function BannerSectionStyle3({
//   bgUrl,
//   imgUrl,
//   title,
//   subTitle,
//   btnText,
//   btnUrl,
// }) {
//   return (
//     <section
//       className="cs_banner cs_style_3 cs_bg_filed"
//       style={{ backgroundImage: `url(${bgUrl})` }}
//     >
//       <div className="cs_banner_img">
//         <img src={imgUrl} alt="Banner" className="cs_main_banner_img" />
//       </div>
//       <div className="container">
//         <div className="cs_banner_text">
//           <h2 className="cs_banner_title cs_fs_72">{title ? parse(String(title)) : null}</h2>
//           <p className="cs_banner_subtitle cs_fs_20 mb-0 cs_heading_color">
//             {subTitle ? parse(String(subTitle)) : null}
//           </p>
//           {btnText && (
//             <>
//               <Spacing md="25" lg="25" xl="25" />
//               <Button btnUrl={btnUrl} btnText={btnText} />
//             </>
//           )}
//         </div>
//       </div>
//     </section>
//   );
// }


export default function BannerStyle3({
  bgUrl = "/images/about/banner_bg.jpg",
  imgUrl = "/images/about/banner_img.png",
  title = "Caring for <em>Life,</em> Every Step",
  subTitle = "Explore our expanding portfolio of pharmaceutical solutions crafted for better patient outcomes.",
  btnText = "Explore Products",
  btnUrl = "/products",
  pillLabel = "Celbion Healthcare",
}) {
  return (
    <>
      <section className="cbs3">
        <div className="cbs3__bg" style={{ backgroundImage: `url(${bgUrl})` }} />
        <div className="cbs3__bg-tint" />
        <div className="cbs3__hex" />
        <div className="cbs3__ray" />
        <div className="cbs3__glow-r" />
        <div className="cbs3__glow-l" />

        {/* Floating image */}
        <div className="cbs3__img-wrap">
          <img src={imgUrl} alt="Banner" className="cbs3__img" />
        </div>

        <div className="cbs3__inner">
          {/* Pill */}
          <div className="cbs3__pill">
            <span className="cbs3__pill-icon">
              <svg viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
            </span>
            <span className="cbs3__pill-text">{pillLabel}</span>
          </div>

          <h2
            className="cbs3__title"
            dangerouslySetInnerHTML={{ __html: title }}
          />

          <div className="cbs3__underline">
            <span className="cbs3__ul-seg" />
            <span className="cbs3__ul-seg" />
            <span className="cbs3__ul-seg" />
          </div>

          <p
            className="cbs3__sub"
            dangerouslySetInnerHTML={{ __html: subTitle }}
          />

          {btnText && (
            <div className="cbs3__btn-group">
              {/* <a href={btnUrl} className="cbs3__btn">
                {btnText}
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="5" y1="12" x2="19" y2="12"/>
                  <polyline points="12 5 19 12 12 19"/>
                </svg>
              </a> */}
              <a href="/about" className="cbs3__btn-outline">
                About Us
              </a>
            </div>
          )}
        </div>
      </section>
    </>
  );
}